const firebaseConfig = {
    apiKey: "AIzaSyDh-SK-buMPIUKEPBA1hUuYzfGJtyBi_t8",
    authDomain: "website-9b61d.firebaseapp.com",
    databaseURL: "https://website-9b61d.firebaseio.com",
    projectId: "website-9b61d",
    storageBucket: "website-9b61d.appspot.com",
    messagingSenderId: "894448193156",
    appId: "1:894448193156:web:d44e586ff5f48e597fbcd1",
    measurementId: "G-148VGSQ6HL"
};

export default firebaseConfig;